<template>
    <div class="nav-box">
        <div class="nav-dropDown" v-if="vm.children&&vm.children.length>0" v-clickoutside="hideSub" @mouseover="showSub" @mouseleave="hideSub">
            <p class="nav-main-item" :class="{ isWhite: !isTop, isRotate: isShow}">{{navName}}</p>
            <div class="nav-sub-box" v-show="isShow">
              <p class="nav-sub-item" :class="{active: $route.path === item.path}" v-for="(item, index) in vm.children" :key="`nsi-${index}`" @click.prevent.stop="goPath(item.path)">{{item.name}}</p>
            </div>
        </div>
        <router-link class="nav-a" v-else :to="vm.path">
          <div class="nav-main-item nav-temp">{{navName}}</div>
        </router-link>
    </div>
</template>
<script>
import '../../directive/click-outside'
export default {
  props: {
    vm: {
      type: Object
    },
    isTop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    navName () {
      if (this.vm && this.vm.children && this.vm.children.length > 0) {
        let curChild = this.vm.children.find(ele => ele.path === this.$route.path)
        return curChild ? curChild.name : this.vm.name
      } else {
        return this.vm.name
      }
    }
  },
  methods: {
    showSub () {
      this.isShow = true
    },
    hideSub () {
      this.isShow = false
    },
    goPath (path) {
      this.isShow = false
      this.$router.push(path)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-box{
  position: relative;
  height: 80px;
  line-height: 80px;
  .nav-main-item{
    line-height: 80px;
    font-size: 15px;
    &:hover{
      font-family: PingFangSC-Semibold;
    }
  }
  .nav-dropDown{
    cursor: pointer;
    position: relative;
    .nav-main-item{
      &::after{
        margin-left: 10px;
        display: inline-block;
        content: ' ';
        width: 12px;
        height: 7px;
        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/header-arrow-white.png') no-repeat;
        background-size: 100% 100%;
        transform-origin: 50% 40%;
        transition: transform .5s;
      }
      &.isWhite::after{
        margin-left: 10px;
        display: inline-block;
        content: ' ';
        width: 12px;
        height: 7px;
        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/header-arrow-black.png') no-repeat;
        background-size: 100% 100%;
        transform-origin: 50% 25%;
        transition: transform .5s;
      }
      &.isRotate::after{
        transition: transform .5s;
        transform: rotate(180deg);
      }
      &:hover{
        font-family: PingFangSC-Semibold;
      }
    }
    .nav-sub-box{
      width: 110px;
      cursor: pointer;
      position: absolute;
      padding: 20px 12px;
      top: 56px;
      left: 50%;
      margin-left: -55px;
      background: #fff;
      box-shadow:0px 3px 5px 0px rgba(0, 0, 0, 0.1);
      border-radius:5px;
      color: #333333;
      text-align: center;
      .nav-sub-item{
        font-family: PingFangSC-Regular;
        color: $base-font-color;
        font-size: 15px;
        line-height: 16px;
        margin-bottom: 23px;
        &:hover{
          color: #FB594A;
        }
        &:last-of-type{
          margin-bottom: 0px;
        }
        &.active{
          color: #FB594A;
        }
      }
    }
  }
  .nav-a {
    color: inherit;
    text-decoration: none;
  }
  &.active{
    .nav-main-item{
      font-size:15px;
      font-family:PingFangSC-Semibold;
    }
  }
}
</style>
